import { useSelector } from 'react-redux';

import useBrains from '@/hooks/useBrains';
import { useModelStrategy } from '@/modules/aiAgents/hooks/useModelStrategy';
import { selectLanguageModelOverride } from '@/modules/tryIt/redux/selectors';
import { legacyDefaultChain, ModelStrategyStep } from '@/shared/types/modelStrategy';

import { selectBrainId } from '../redux/selectors';

export const useOutgoingModelStep = (): ModelStrategyStep | undefined => {
  const brainId = useSelector(selectBrainId);
  const override = useSelector(selectLanguageModelOverride);
  const { brain } = useBrains(brainId);
  const { strategy, getStatus, canRead } = useModelStrategy(brainId);

  if (override) {
    return override;
  }
  if (canRead && getStatus !== 'success') {
    return undefined;
  }
  const configured = strategy.chat.length > 0 ? strategy.chat : strategy.default;
  if (configured[0]) {
    return configured[0];
  }
  return brain ? legacyDefaultChain(brain.language_model_id)[0] : undefined;
};
